import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const CheckAll = () => {
  const { t } = useTranslation();

  const [checkedAll, setCheckedAll] = useState<boolean>(false);

  const checkUncheckAll = () => {
    const checkboxes: NodeListOf<HTMLLabelElement> = document.querySelectorAll(
      `.Search__Results .WebformCheckboxes__checkbox__input.${checkedAll ? 'icon-variant-1' : 'icon-variant-0'}`,
    );

    checkboxes.forEach((checkbox) => {
      checkbox.click();
    });

    setCheckedAll(!checkedAll);
  };

  return (
    <div className="SearchAllContent__CheckAll">
      <div className="SearchAllContent__CheckAll__wrapper">
        <button
          className="SearchAllContent__CheckAll__button"
          type="button"
          onClick={() => checkUncheckAll()}
        >
          {checkedAll
            ? <><i className="icon icon-check-box-checked" />{t('components.export.uncheck')}</>
            : <><i className="icon icon-check-box" />{t('components.export.check')}</>}
        </button>
      </div>
      {t('components.export.check_help')}
    </div>
  );
};

export default CheckAll;
